export const SEND_NOTIFICATION_SUCCESS = 'NOTIFICATION/SEND_NOTIFICATION_SUCCESS';
export const SEND_NOTIFICATION_ERROR = 'NOTIFICATION/SEND_NOTIFICATION_ERROR';
